module.exports = __webpack_public_path__ + "ir.svg?4eca31ff722fa429de3c2bd75008c79b";